module.exports = __webpack_public_path__ + "static/media/1.Complete Solution Drip Irrigation.22ab5e25.jpeg";